module.exports = __webpack_public_path__ + "img/4_lfw_fr.12909054.jpg";